const breakpointDesktop = 1280;
const breakpointMobile = 1024;
const isDesktop = window.matchMedia(`(min-width: ${breakpointDesktop}px)`);
const isMobile = window.matchMedia(`(max-width: ${breakpointMobile - 1}px)`);
const isTablet = window.matchMedia(
	`(min-width: ${breakpointMobile}px) and (max-width: ${breakpointDesktop}px)`
);

export { breakpointDesktop, breakpointMobile, isDesktop, isMobile, isTablet };
